import { ApolloClient } from '@apollo/client';
import { unitPlannerFragment } from 'approot/unit/unit.graphql';
import type { UnitPlannerFragment } from '../unit.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export function updateUnitInPlannerCache(
  client: ApolloClient<any>,
  unitId: number,
  newUnitPlannersInfo: Pluck<UnitPlannerFragment, 'unitPlannersInfo'>[]
) {
  const data = client.readFragment<UnitPlannerFragment>({
    id: `Unit:${unitId}`,
    fragment: unitPlannerFragment,
  });

  if (data) {
    const updatedData = { ...data };
    updatedData.unitPlannersInfo = newUnitPlannersInfo;

    client.writeFragment<UnitPlannerFragment>({
      id: `Unit:${unitId}`,
      fragment: unitPlannerFragment,
      data: updatedData,
    });
  }
}

export type AddToPlannerLabelProps = {
  label: string;
  isItemInPlanner?: boolean;
  isUnitInPlanner?: boolean;
  termNumber?: number;
  isAriaLabel?: boolean;
  isPlannerUnit?: boolean;
};

export function getAddToPlannerButtonLabel({
  label,
  isItemInPlanner = false,
  isUnitInPlanner = false,
  termNumber = 0,
  isAriaLabel,
  isPlannerUnit = false,
}: AddToPlannerLabelProps) {
  if (isAriaLabel) {
    if (!termNumber || !isUnitInPlanner) {
      return `Add "${label}" to Planner`;
    } else if (isItemInPlanner || isPlannerUnit) {
      return `In your Term ${termNumber} Planner - Change Term for "${label}"`;
    } else {
      return `Add "${label}" to Term ${termNumber} in your Planner`;
    }
  } else {
    if (!termNumber || !isUnitInPlanner) {
      return `Add to Planner`;
    } else if (isItemInPlanner || isPlannerUnit) {
      return 'In your Planner';
    } else {
      return `Add to Planner`;
    }
  }
}
